import VimmiAI from 'vimmi-analytics-integration/dist/vimmi-analytics-integration.cjs';
import Tools from '../services/tools';
import Config from '../services/config';
import vimmiPI from '../plugins/vimmiPI';
import vjsSrv from '../services/vjsSrv';
import { screenMode } from 'vimmi-web-utils/cjs/screenMode';
import $logger from 'src/js/logger';


export class PlayerAnalytics {
  constructor() {
    this.analyticModule = new VimmiAI();
    vimmiPI.attachAnalytics(this);
  }

  configure(configs) {
    if (configs.portal) {
      this.analyticModule.conf({
        app_id: configs.portal.app_id,
        platform: Config.get('platform'),
        app_version: configs.portal.app_version,
        device_id: configs.portal.device_id,
        buhDeviceId: configs.portal.buhDeviceId || configs.portal.device_id,
        language: configs.portal.user_lang
      });
    }
    if (configs.analytics) {
      if (configs.analytics?.debug) {
        this.analyticModule.debug(configs.analytics.debug);
      }
      let drivers = [];
      if (configs.analytics.buh) {
        drivers.push(this.analyticModule.setDriver(VimmiAI.DRIVERS.BUH, configs.analytics.buh, { storageKey: 'buhPlayerEventsBuffer' }));
      }
      /** todo: other drivers */
      Promise.all(drivers).then((resull) => {
        let err = this.analyticModule.initialize();
        if (err) {
          $logger.p('analytics/configure').warn('drivers initialization error: ', err);
        }
      });
    }
  }

  beforePlay(activeAsset) {
    /** temporary only for catchmedia*/
    // for (let key in PlayerAnalytics.instances) {
    //     if (PlayerAnalytics.instances[key].beforePlay) {
    //         PlayerAnalytics.instances[key].beforePlay(activeAsset);
    //     }
    // }
  }


  resetCalculatedOptions(activeAsset) {
    if (!activeAsset) {
      return;
    }
    activeAsset.set('extraData.bytes', 0);
    activeAsset.set('extraData.active_bitrate', 0);
    activeAsset.set('extraData.jump', 0);
    activeAsset.set('extraData.buffer_time', 0);
    activeAsset.set('extraData.stream_time', 0);
    activeAsset.set('extraData.position_from', 0);
    activeAsset.set('extraData.position_to', 0);
    activeAsset.set('extraData.active_position', 0);
    activeAsset.set('extraData.max_view_bitrate', 0);
    activeAsset.set('extraData.actual_max_bitrate', 0);
    activeAsset.set('extraData.buh.chu_bitrate', []);
    activeAsset.set('extraData.buh.total_average_bitrate', []);
    activeAsset.set('extraData.buh.missedBytes', null);


    activeAsset.set('extraData.buh.resume_bytes', 0);
    activeAsset.set('extraData.buh.resume_buffer_time', 0);
    activeAsset.set('extraData.buh.resume_actual_max_bitrate', 0);
    activeAsset.set('extraData.buh.resume_jump', 0);
    activeAsset.set('extraData.buh.resume_stream_time', 0);
    activeAsset.set('extraData.buh.resume_bitrate', []);
    activeAsset.set('extraData.buh.resume_duration', Date.now());

    activeAsset.set('extraData.buh.stop_bytes', 0);
    activeAsset.set('extraData.buh.stop_jump', 0);
    activeAsset.set('extraData.buh.stop_buffer_time', 0);
    activeAsset.set('extraData.buh.stop_actual_max_bitrate', 0);
    activeAsset.set('extraData.buh.stop_stream_time', 0);

    activeAsset.set('extraData.buh.pause_bytes', 0);
    activeAsset.set('extraData.buh.pause_jump', 0);
    activeAsset.set('extraData.buh.pause_buffer_time', 0);
    activeAsset.set('extraData.buh.pause_actual_max_bitrate', 0);
    activeAsset.set('extraData.buh.pause_stream_time', 0);

    activeAsset.set('extraData.buh.chu_bytes', 0);
    activeAsset.set('extraData.buh.chu_buffer_time', 0);
    activeAsset.set('extraData.buh.chu_actual_max_bitrate', 0);
    activeAsset.set('extraData.buh.chu_jump', 0);
    activeAsset.set('extraData.buh.chu_stream_time', 0);
  }


  getQoS(asset, buffer_time, stream_time, jumps) {
    // formula: (50 * BF) + (30 * STRMQ) + (20 * RJMP)
    // Where: BF: (1 - buffer_time/stream_time). STRMQ: (bitrate/max_bitrate). RJMP: (1 - min(10,jump) / 10).

    /** old option */
    // let res = Math.round(
    //     (50 * (1 - (buffer_time ? (buffer_time / stream_time) : 0))) +
    //     (30 * (asset.get('extraData.active_bitrate', 1) / asset.get('extraData.max_bitrate'))) +
    //     (20 * (1 - (Math.min(jumps, 10) / 10)))
    // );

    /** new option */
    let res = Math.round(
      (50 * (stream_time / ((buffer_time || 0) + stream_time))) +
      (30 * Math.min(asset.get('extraData.active_bitrate', 1) / asset.get('extraData.max_bitrate'), 1)) +
      (20 * (1 - (Math.min(jumps, 10) / 10)))
    );

    //  $logger.p('analytics/QoS').debug('#getQoS', {
    //     buffer_time: buffer_time,
    //     stream_time: stream_time,
    //     max_bitrate: asset.get('extraData.max_bitrate'),
    //     bitrate: asset.get('extraData.active_bitrate', 1),
    //     jump: jumps,
    //     part1: (50 * (1 - (buffer_time && stream_time ? (buffer_time / stream_time) : 0))),
    //     part2: (30 * (asset.get('extraData.active_bitrate', 1) / asset.get('extraData.max_bitrate'))),
    //     part3: (20 * (1 - (Math.min(jumps, 10) / 10))),
    //     res: res
    // });

    return isNaN(res) || res === Infinity || res === null ? 100 : res < 0 ? 0 : res > 100 ? 100 : res;
  }


  getBufferTime(bufferTime) {
    return bufferTime ? Tools.toNatural(Tools.fixTo(bufferTime)) : 0;
  }

  getBufferRatio(bufferTime, streamTime) {
    //    let bufferTime = this.getBufferTime(asset.get('extraData.buffer_time'));
    return bufferTime ? Tools.toNatural(Tools.fixTo(bufferTime / (streamTime + bufferTime))) : 0;
  }


  _getFormatedError(error) {
    return {
      error_name: error.type || error.name || 'unknown error',
      error_code: error.status || error.statusCode || error.code,
      error_description: error.message || error.status || 'unknown error',
      error_source: error.source || ((error.status || error.statusCode || (error.code <= 2 && error.code >= 1) || error.code === 4) ?
        'HTTP' : 'Player')
    };
  }

  getAverageBitrate(total_average_bitrate) {
    if (total_average_bitrate && total_average_bitrate.length) {
      return Tools.fixTo(total_average_bitrate.reduce((a, b) => {
        return a + b;
      }) / total_average_bitrate.length);
    }
    return null;
  }

  _getEventData(evn, options) {
    let asset = options.asset || vimmiPI.getActiveAsset() || {
      get: function(key, defaultVal) {
        return defaultVal || null;
      },
      set() {

      }
    };
    let activePlayback = asset.get('activePlayback') || {};

    // let appEvents = ['play_request', 'play_response', 'play_error'/* 'meta_request', 'meta_response', 'meta_error'*/];
    let data = {
      app_info: Config.get(`params.portal.app_info`),
      app_version: Config.get(`params.portal.app_version`),
      customer: (Config.get(`params.portal.customer`) || '').toLowerCase(),
      user_id: Config.get(`params.portal.user_id`),
      session_id: Config.get(`params.portal.sid`)
    };
    if (Config.get(`params.portal.target_site`)) {
      data.target_site = Config.get(`params.portal.target_site`);
    }

    if (!Config.get(`params.portal.user_id`)) {
      data.temp_user_id = Config.get(`params.portal.temp_user_id`);
    }

    if (Config.get(`params.portal.classification`)) {
      data.classification = Config.get(`params.portal.classification`);
    }

    if (this.analyticModule.getEventType(evn) === 'media') {
      data.player = 'vimmi-web';
      data.player_version = process.env.version;
      data.streaming_server_id = asset.get('activePlayback.serverId');
      data.media_session_id = (Config.get(`params.portal.user_id`) || Config.get(`params.portal.temp_user_id`) || 'unknown') + '_' + asset.get('media_session_id');//|| this.updateMSI(asset);
      data.media_id = asset.get('alphaId') || null;
      data.itype = asset.get('itype') || null;
      data.subscription_status = asset.get('extraData.subscription_status') || null;
      data.item_language = vjsSrv.vjsPlayer
        .TechSrv
        .getActiveAudioTrack();
      data.position = (vjsSrv.vjsPlayer.duration() === Infinity || asset.isLive) ? 0 : Tools.fixTo(asset.get('extraData.active_position', 0), 0);
      data.playback_url = activePlayback.url ? activePlayback.url.toString() : null;
      data.item_id = asset.get('media_id');
      data.auto_play = !!asset.get('extraData.isAutoPlayed');

      if (asset.get('preview_info') !== null) {
        data.tag = 'preview';
      }
    } else {
      data.server = Config.get(`params.portal.server`);
    }


    let total_average_bitrate = asset.get('extraData.buh.total_average_bitrate') || [];

    let cdn = asset.get('activePlayback.cdn');
    if (cdn) {
      let purifiedCdn = cdn.replace(/-https/g, '');
      asset.set('activePlayback.cdn', purifiedCdn);
    }

    switch (evn) {
      case 'player_ready': // sends before start
        data = Object.assign(data, {
          bitrate: Tools.toNatural(asset.get('extraData.active_bitrate', 0)),
          bytes: Tools.toNatural(asset.get('extraData.bytes', 0)),
          // qos: this.getQoS(asset, asset.get('extraData.buffer_time'), asset.get('extraData.stream_time', 0), asset.get('extraData.jump')),
          context: asset.get('extraData.context'),
          cur_stream: asset.get('extraData.active_stream') || 1,
          delay: Tools.toNatural(Tools.fixTo(asset.get('extraData.delay_end') ? asset.get('extraData.delay_end') - asset.get('extraData.delay_start') : 0, 0)),
          cdn: asset.get('activePlayback.cdn'), //- not described in the doc
          //          buffer_ratio: this.getBufferRatio(asset.get('extraData.buffer_time'), asset.get('extraData.stream_time', 0)),
          max_bitrate: asset.get('extraData.max_bitrate', 0),
          min_bitrate: asset.get('extraData.min_bitrate', 0),
          n_streams: asset.get('extraData.n_streams', 0),
          //          jump: asset.get('extraData.jump', 0),
          //          stream_time: asset.get('extraData.stream_time', 0),
          //          item_id: asset.get('media_id'),
          click_to_media: Tools.toNatural(Tools.fixTo(asset.get('extraData.click_to_media_end') ? asset.get('extraData.click_to_media_end') - asset.get('extraData.click_to_media_start') : 0, 0))
        });
        delete data.position;
        break;
      case 'start':
        if (!asset.get('extraData.first_byte_end')) {
          asset.set('extraData.first_byte_end', Date.now());
        }
        data = Object.assign(data, {
          first_byte: Tools.toNatural(Tools.toNatural(Tools.fixTo(asset.get('extraData.first_byte_end') ? asset.get('extraData.first_byte_end') - asset.get('extraData.first_byte_start') : 0, 0))),
          bitrate: Tools.toNatural(Tools.toNatural(asset.get('extraData.active_bitrate', 0))),
          bytes: Tools.toNatural(Tools.toNatural(asset.get('extraData.bytes', 0))),
          qos: this.getQoS(asset, asset.get('extraData.buffer_time'), asset.get('extraData.stream_time', 0), asset.get('extraData.jump')),
          cur_stream: asset.get('extraData.active_stream') || 1,
          context: asset.get('extraData.context'),
          cdn: asset.get('activePlayback.cdn'), //- not described in the doc
          buffer_ratio: this.getBufferRatio(asset.get('extraData.buffer_time'), asset.get('extraData.stream_time', 0)),
          max_bitrate: asset.get('extraData.max_bitrate', 0),
          min_bitrate: asset.get('extraData.min_bitrate', 0),
          n_streams: asset.get('extraData.n_streams', 0),
          jump: asset.get('extraData.jump', 0),
          stream_time: Tools.toNatural(Tools.fixTo(asset.get('extraData.stream_time', 0))),
          //          item_id: asset.get('media_id'),
          buffer_time: Tools.toNatural(Tools.fixTo(asset.get('extraData.buffer_time', 0))),
          actual_max_bitrate: Tools.fixTo(asset.get('extraData.actual_max_bitrate', asset.get('extraData.active_bitrate', 0)), 0),
          click_to_media: Tools.toNatural(Tools.fixTo(asset.get('extraData.click_to_media_end') ? asset.get('extraData.click_to_media_end') - asset.get('extraData.click_to_media_start') : 0, 0))
        });
        asset.set('extraData.buh.start_streaming', Date.now());
        break;
      case 'chu':
        let chu_buffer_time = this.getBufferTime(
          asset.get('extraData.buffer_time', 0) - (asset.get('extraData.buh.chu_buffer_time', 0)));
        let chu_stream_time = asset.get('extraData.stream_time', 0) - (asset.get('extraData.buh.chu_stream_time', 0));
        let chu_jumps = asset.get('extraData.jump') - (asset.get('extraData.buh.chu_jump', 0));
        chu_stream_time = chu_stream_time < 0 ? 0 : chu_stream_time;
        let chu_bitrate = asset.get('extraData.buh.chu_bitrate', []);
        let chu_average_bitrate = asset.get('extraData.active_bitrate', 0);
        if (chu_bitrate && chu_bitrate.length) {
          chu_average_bitrate = (chu_bitrate.reduce((a, b) => {
            return a + b;
          }) / chu_bitrate.length);
        }

        /** to colect for player next events*/
        total_average_bitrate.push(chu_average_bitrate);
        asset.set('extraData.buh.total_average_bitrate', total_average_bitrate);
        /** end */

        data = Object.assign(data, {
          bitrate: Tools.toNatural(Tools.fixTo(chu_average_bitrate)),
          duration: Tools.fixTo(chu_buffer_time + (chu_stream_time < 0 ? 0 : chu_stream_time)),
          cdn: asset.get('activePlayback.cdn'), //- not described in the doc
          cur_stream: asset.get('extraData.active_stream') || 1,
          //          item_id: asset.get('media_id'),
          max_bitrate: asset.get('extraData.max_bitrate', 0),
          min_bitrate: asset.get('extraData.min_bitrate', 0),
          n_streams: asset.get('extraData.n_streams', 0),
          buffer_time: chu_buffer_time,
          bytes: Tools.toNatural(asset.get('extraData.bytes', 1) - (asset.get('extraData.buh.chu_bytes', 0))),
          buffer_ratio: this.getBufferRatio(chu_buffer_time, chu_stream_time),
          qos: this.getQoS(asset, chu_buffer_time, chu_stream_time, chu_jumps),
          actual_max_bitrate: Tools.fixTo(asset.get('extraData.buh.chu_actual_max_bitrate', asset.get('extraData.active_bitrate', 0)), 0),
          jump: chu_jumps,
          stream_time: Tools.toNatural(Tools.fixTo(chu_stream_time < 0 ? 0 : chu_stream_time))
        });

        asset.set('extraData.buh.chu_bytes', asset.get('extraData.bytes', 0));
        asset.set('extraData.buh.chu_buffer_time', asset.get('extraData.buffer_time', 0));
        asset.set('extraData.buh.chu_actual_max_bitrate', asset.get('extraData.active_bitrate', 0));
        asset.set('extraData.buh.chu_jump', asset.get('extraData.jump'));
        asset.set('extraData.buh.chu_stream_time', asset.get('extraData.stream_time', 0));
        asset.set('extraData.buh.chu_bitrate', []);

        break;

      case 'media_pause':
        let pause_buffer_time = this.getBufferTime(
          asset.get('extraData.buffer_time', 0) - (asset.get('extraData.buh.pause_buffer_time', 0)));
        let pause_stream_time = asset.get('extraData.stream_time', 0) - (asset.get('extraData.buh.pause_stream_time', 0));
        let pause_jumps = asset.get('extraData.jump') - (asset.get('extraData.buh.pause_jump', 0));
        pause_stream_time = pause_stream_time < 0 ? 0 : pause_stream_time;
        data = Object.assign(data, {
          n_streams: asset.get('extraData.n_streams', 0),
          cur_stream: asset.get('extraData.active_stream', 1),
          max_bitrate: asset.get('extraData.max_bitrate', 0),
          min_bitrate: asset.get('extraData.min_bitrate', 0),
          //          item_id: asset.get('media_id'),
          buffer_time: pause_buffer_time,
          cdn: asset.get('activePlayback.cdn'), //- not described in the doc
          stream_time: Tools.toNatural(Tools.fixTo(pause_stream_time)),
          buffer_ratio: this.getBufferRatio(pause_buffer_time, pause_stream_time),
          qos: this.getQoS(asset, pause_buffer_time, pause_stream_time, pause_jumps),
          bitrate: Tools.toNatural(this.getAverageBitrate(total_average_bitrate) || Tools.fixTo(asset.get('extraData.active_bitrate', 0))),
          bytes: Tools.toNatural(asset.get('extraData.bytes', 1) - (asset.get('extraData.buh.pause_bytes', 0))),
          actual_max_bitrate: Tools.fixTo(asset.get('extraData.buh.pause_actual_max_bitrate', asset.get('extraData.active_bitrate', 0)), 0),
          jump: pause_jumps,
          duration: Tools.fixTo(pause_buffer_time + pause_stream_time)
        });
        asset.set('extraData.buh.pause_bytes', asset.get('extraData.bytes', 0));
        asset.set('extraData.buh.pause_jump', asset.get('extraData.jump'));
        asset.set('extraData.buh.pause_buffer_time', asset.get('extraData.buffer_time', 0));
        asset.set('extraData.buh.pause_actual_max_bitrate', asset.get('extraData.active_bitrate', 0));
        asset.set('extraData.buh.pause_stream_time', asset.get('extraData.stream_time', 0));

        asset.set('extraData.buh.resume_bytes', asset.get('extraData.bytes', 0));
        asset.set('extraData.buh.resume_buffer_time', asset.get('extraData.buffer_time', 0));
        asset.set('extraData.buh.resume_actual_max_bitrate', asset.get('extraData.active_bitrate', 0));
        asset.set('extraData.buh.resume_jump', asset.get('extraData.jump'));
        asset.set('extraData.buh.resume_stream_time', asset.get('extraData.stream_time', 0));
        asset.set('extraData.buh.resume_bitrate', []);
        asset.set('extraData.buh.resume_duration', Date.now());
        break;
      case 'media_resume':

        let resume_buffer_time = this.getBufferTime(
          asset.get('extraData.buffer_time', 0) - (asset.get('extraData.buh.resume_buffer_time', 0)));
        let resume_stream_time = asset.get('extraData.stream_time', 0) - (asset.get('extraData.buh.resume_stream_time', 0));
        let resume_jumps = asset.get('extraData.jump') - (asset.get('extraData.buh.resume_jump', 0));
        resume_stream_time = resume_stream_time < 0 ? 0 : resume_stream_time;
        let resume_bitrate = asset.get('extraData.buh.resume_bitrate', []);
        let resume_average_bitrate = asset.get('extraData.active_bitrate', 0);
        if (resume_bitrate && resume_bitrate.length) {
          resume_average_bitrate = (resume_bitrate.reduce((a, b) => {
            return a + b;
          }) / resume_bitrate.length);
        }

        /** to colect for player next events*/
        total_average_bitrate.push(resume_average_bitrate);
        asset.set('extraData.buh.total_average_bitrate', total_average_bitrate);
        /** end */

        data = Object.assign(data, {
          bitrate: Tools.toNatural(Tools.fixTo(resume_average_bitrate)),
          duration: Tools.fixTo(
            (Date.now() - (asset.get('extraData.buh.resume_duration') || asset.get('extraData.buh.start_streaming', 0))) / 1000), // it is timeout between chu events !not video duration
          cdn: asset.get('activePlayback.cdn'), //- not described in the doc
          cur_stream: asset.get('extraData.active_stream', 1),
          //          item_id: asset.get('media_id'),
          max_bitrate: asset.get('extraData.max_bitrate', 0),
          min_bitrate: asset.get('extraData.min_bitrate', 0),
          n_streams: asset.get('extraData.n_streams', 0),
          buffer_time: resume_buffer_time,
          buffer_ratio: Tools.toNatural(this.getBufferRatio(resume_buffer_time, resume_stream_time)),
          bytes: Tools.toNatural(asset.get('extraData.bytes', 1) - (asset.get('extraData.buh.resume_bytes', 0))),
          qos: this.getQoS(asset, resume_buffer_time, resume_stream_time, resume_jumps),
          actual_max_bitrate: Tools.fixTo(asset.get('extraData.buh.resume_actual_max_bitrate', asset.get('extraData.active_bitrate', 0)), 0),
          jump: resume_jumps,
          stream_time: Tools.toNatural(Tools.fixTo(resume_stream_time))
        });

        asset.set('extraData.buh.resume_bytes', asset.get('extraData.bytes', 0));
        asset.set('extraData.buh.resume_buffer_time', asset.get('extraData.buffer_time', 0));
        asset.set('extraData.buh.resume_actual_max_bitrate', asset.get('extraData.active_bitrate', 0));
        asset.set('extraData.buh.resume_jump', asset.get('extraData.jump', 0));
        asset.set('extraData.buh.resume_stream_time', asset.get('extraData.stream_time', 0));
        asset.set('extraData.buh.resume_bitrate', []);
        asset.set('extraData.buh.resume_duration', Date.now());

        asset.set('extraData.buh.stop_bytes', asset.get('extraData.bytes', 0));
        asset.set('extraData.buh.stop_jump', asset.get('extraData.jump', 0));
        asset.set('extraData.buh.stop_buffer_time', asset.get('extraData.buffer_time', 0));
        asset.set('extraData.buh.stop_actual_max_bitrate', asset.get('extraData.active_bitrate', 0));
        asset.set('extraData.buh.stop_stream_time', asset.get('extraData.stream_time', 0));

        asset.set('extraData.buh.pause_bytes', asset.get('extraData.bytes', 0));
        asset.set('extraData.buh.pause_jump', asset.get('extraData.jump'));
        asset.set('extraData.buh.pause_buffer_time', asset.get('extraData.buffer_time', 0));
        asset.set('extraData.buh.pause_actual_max_bitrate', asset.get('extraData.active_bitrate', 0));
        asset.set('extraData.buh.pause_stream_time', asset.get('extraData.stream_time', 0));

        asset.set('extraData.buh.chu_bytes', asset.get('extraData.bytes', 0));
        asset.set('extraData.buh.chu_buffer_time', asset.get('extraData.buffer_time', 0));
        asset.set('extraData.buh.chu_actual_max_bitrate', asset.get('extraData.active_bitrate', 0));
        asset.set('extraData.buh.chu_jump', asset.get('extraData.jump', 0));
        asset.set('extraData.buh.chu_stream_time', asset.get('extraData.stream_time', 0));
        asset.set('extraData.buh.chu_bitrate', []);
        break;
      case 'stop':
        let stop_buffer_time = this.getBufferTime(
          asset.get('extraData.buffer_time', 0) - (asset.get('extraData.buh.stop_buffer_time', 0)));
        let stop_stream_time = asset.get('extraData.stream_time', 0) - (asset.get('extraData.buh.stop_stream_time', 0));
        let stop_jumps = asset.get('extraData.jump') - (asset.get('extraData.buh.stop_jump', 0));
        stop_stream_time = stop_stream_time < 0 ? 0 : stop_stream_time;
        data = Object.assign(data, {

          cdn: asset.get('activePlayback.cdn') || null,
          n_streams: asset.get('extraData.n_streams', 0),
          cur_stream: asset.get('extraData.active_stream', 1),
          max_bitrate: asset.get('extraData.max_bitrate', 0),
          min_bitrate: asset.get('extraData.min_bitrate', 0),
          //          item_id: asset.get('media_id'),
          buffer_time: stop_buffer_time,
          stream_time: Tools.toNatural(Tools.fixTo(stop_stream_time)),
          buffer_ratio: this.getBufferRatio(stop_buffer_time, stop_stream_time),
          qos: this.getQoS(asset, stop_buffer_time, stop_stream_time, stop_jumps),
          bitrate: Tools.toNatural(this.getAverageBitrate(total_average_bitrate) || Tools.fixTo(asset.get('extraData.active_bitrate', 0))),
          bytes: Tools.toNatural(asset.get('extraData.bytes', 1) - (asset.get('extraData.buh.stop_bytes', 0))),
          actual_max_bitrate: Tools.fixTo(asset.get('extraData.buh.stop_actual_max_bitrate', asset.get('extraData.active_bitrate', 0)), 0),
          jump: stop_jumps,
          duration: Tools.fixTo(stop_buffer_time + stop_stream_time)
        });
        asset.set('extraData.buh.stop_bytes', asset.get('extraData.bytes', 0));
        asset.set('extraData.buh.stop_jump', asset.get('extraData.jump', 0));
        asset.set('extraData.buh.stop_buffer_time', asset.get('extraData.buffer_time', 0));
        asset.set('extraData.buh.stop_actual_max_bitrate', asset.get('extraData.active_bitrate', 0));
        asset.set('extraData.buh.stop_stream_time', asset.get('extraData.stream_time', 0));
        break;
      case 'media_is_playing':
        // data.item_id = asset.get('media_id');
        data.delay = Tools.fixTo(asset.get('extraData.delay_end') ? asset.get('extraData.delay_end') - asset.get('extraData.delay_start') : 0, 0);
        data.click_to_media = Tools.fixTo(asset.get('extraData.click_to_media_end') ? asset.get('extraData.click_to_media_end') - asset.get('extraData.click_to_media_start') : 0, 0);
        data.cdn = asset.get('activePlayback.cdn');
        break;
      case 'media_error'://+
        data = Object.assign(data, this._getFormatedError(options.error));
        data.cdn = asset.get('activePlayback.cdn');
        break;
      case 'media_buffering_start':
      case 'media_buffering_completed':
        data.cdn = asset.get('activePlayback.cdn');
        break;
      case 'abort'://+
        data = Object.assign(data, this._getFormatedError(options.error));
        //        data = Object.assign(data, this._getFormatedError(options.error || {}));
        break;
      case 'seek': //+
        data = Object.assign(data, {
          //          item_id: asset.get('media_id'),
          from_time: Tools.fixTo(asset.get('extraData.position_from', 0)),
          to_time: Tools.fixTo(asset.get('extraData.position_to'))
        });
        break;
      case 'media_screen_switch': //+
        data = Object.assign(data, {
          tar_screen_mode: screenMode()
        });
        break;
      case 'meta_request':
        data = Object.assign(data, {
          screen_type: asset.get('extraData.screen_type'), // unavailable in player
          screen_id: asset.get('extraData.screen_id'), // unavailable in player
          //          item_id: asset.get('media_id'),
          itype: asset.get('itype')
        });
        break;
      case 'meta_response':
        data = Object.assign(data, {
          screen_type: asset.get('extraData.screen_type'), // unavailable in player
          screen_id: asset.get('extraData.screen_id'), // unavailable in player
          //          item_id: asset.get('media_id'),
          itype: asset.get('itype')
        });
        break;
      case 'meta_error':
        data = Object.assign(data, {
          screen_type: asset.get('extraData.screen_type'), // unavailable in player
          screen_id: asset.get('extraData.screen_id'), // unavailable in player
          //          item_id: asset.get('media_id'),
          itype: asset.get('itype')
        }, this._getFormatedError(options.error));
        break;
      /** App events */
      case 'play_request':
        data = Object.assign(data, {
          screen_type: asset.get('extraData.screen_type'), // unavailable in player
          screen_id: asset.get('extraData.screen_id'), // unavailable in player
          item_id: asset.get('media_id'),
          itype: asset.get('itype'),
          click_to_media: Tools.fixTo(asset.get('extraData.click_to_media_end') ? asset.get('extraData.click_to_media_end') - asset.get('extraData.click_to_media_start') : 0, 0),
          content_title: asset.get('extraData.title')
        });
        break;
      case 'play_response':
        data = Object.assign(data, {
          screen_type: asset.get('extraData.screen_type'), // unavailable in player
          screen_id: asset.get('extraData.screen_id'), // unavailable in player
          item_id: asset.get('media_id'),
          itype: asset.get('itype'),
          content_title: asset.get('extraData.title')
        });
        break;
      case 'play_error':
        data = Object.assign(data, {
          screen_type: asset.get('extraData.screen_type'), // unavailable in player
          screen_id: asset.get('extraData.screen_id'), // unavailable in player
          item_id: asset.get('media_id'),
          itype: asset.get('itype'),
          content_title: asset.get('extraData.title')
        }, this._getFormatedError(options.error));
        break;

    }
    return data;
  }

  onTimeUpdate(asset) {

    if (!asset) {
      return;
    }
    if (asset.get('extraData.start_buffering') && asset.get('extraData.active_position') !==
      vjsSrv.vjsPlayer
        .currentTime()) {
      let buffering_time = Date.now() - asset.get('extraData.start_buffering');
      let total_buffer_time = asset.get('extraData.buffer_time', 0);
      asset.set('extraData.buffer_time', total_buffer_time + (buffering_time / 1000));
      asset.set('extraData.start_buffering', null);
      this.send('media_buffering_completed');
    }

    if (vjsSrv.vjsPlayer
      .TechSrv
      .stats) {
      let currentBitrate = asset.get('extraData.active_bitrate', 0);
      if (currentBitrate > asset.get('extraData.actual_max_bitrate', 0)) {
        asset.set('extraData.actual_max_bitrate', currentBitrate);
      }

      if (currentBitrate > asset.get('extraData.buh.chu_actual_max_bitrate')) {
        asset.set('extraData.buh.chu_actual_max_bitrate', currentBitrate);
      }
      if (currentBitrate > asset.get('extraData.buh.pause_actual_max_bitrate')) {
        asset.set('extraData.buh.pause_actual_max_bitrate', currentBitrate);
      }
      if (currentBitrate > asset.get('extraData.buh.stop_actual_max_bitrate')) {
        asset.set('extraData.buh.stop_actual_max_bitrate', currentBitrate);
      }

      let chuBitrates = asset.get('extraData.buh.chu_bitrate') || [];
      chuBitrates.push(currentBitrate);
      asset.set('extraData.buh.chu_bitrate', chuBitrates);
    }
  }

  send(event, event_extra_data = {}, options = {}) {

    // need to send each 'conf.chugap' seconds
    // if 'force' then allow
    if (!options.force && event === 'chu' && (Math.round(vjsSrv.vjsPlayer
      .currentTime()) === 0 || (Math.round(vjsSrv.vjsPlayer
      .currentTime()) % Config.get('params.analytics.buh.chugap') !== 0))) {
      return;
    }

    let computedExtraData =
      Object.assign({}, this._getEventData(event, options), event_extra_data);

    this.analyticModule.send(event, computedExtraData, {
      beacon: !!options.beacon,
      fetch: !!options.fetch,
      only: options.only || null,
      buffer_timestamp: options.buffer_timestamp || null
    });
  }


  beforePageClose(options) {
    this.analyticModule.beforePageClose(options);
  }

}

const Analytics = new PlayerAnalytics();

export default Analytics;